import React, { useContext, useState } from 'react';

import { Upload } from "@progress/kendo-react-upload";
import { AppContext } from '../../App';
import { getMediaFilePath } from '../../functions/get-media-file-path';

const UploadField = ({ label, name, defaultFile, value, onChange, setValue, placeholder, register, explanation, rules, error, disabled }) => {
    const [uploadId, setUploadId] = useState(null);
    const appContext = useContext(AppContext);
    const [files, setFiles] = useState([]);
    const inputFieldName = name + "_file";
    const reg = register ? {...register(inputFieldName, rules)} : null;
    if (reg && !reg.value && defaultFile) {
        reg.value = defaultFile;
    }
    const previewFile = getMediaFilePath(defaultFile);
    
    return (
        <div className='mb-3 flex flex-col w-full'>
            <label className='text-brandDarkBlue text-sm font-bold pr-6 mb-1'>{label} {rules && rules.required && <span className='text-red'>*</span>}</label>
            <div className='flex flex-col'>                
                <Upload
                saveField="file"
                batch={true}
                multiple={false}
                defaultFiles={files}
                withCredentials={true}
                saveUrl={`${appContext.apiBaseUrl}/fileupload`}
                removeUrl={`${appContext.apiBaseUrl}/fileupload/remove/${uploadId}`}
                disabled={disabled}
                onStatusChange ={event => {
                    if (event.newState[0].status == 4 && event.response.status == 200) {
                        setUploadId(event.response.response.uploadId);
                        
                        if (onChange) {
                            onChange({
                                target: {
                                    name,
                                    value: event.response.response.uploadId,
                                    info: event.response.response
                                },
                                resetFiles: () => setFiles([])
                            });
                        }

                        if (setValue) {
                            setValue(name, event.response.response);
                            setValue(inputFieldName, event.response.response.uploadId);
                        }

                        if (reg) {
                            reg.onChange({
                                target: {
                                    name: inputFieldName,
                                    value: event.response.response.uploadId
                                }
                            });
                        }
                    }
                }}
                onRemove={event => {
                    if (event.response.status == 200) {
                        setUploadId(null);        
                        
                        if (onChange) {
                            onChange({
                                target: {
                                    name,
                                    value: null,
                                    info: {}
                                }
                            });
                        }

                        if (setValue) {
                            setValue(name, null);
                            setValue(inputFieldName, null);
                        }

                        if (reg) {
                            reg.onChange({
                                target: {
                                    name: inputFieldName,
                                    value: null
                                }
                            });
                        }
                    }
                }}
                />
                {previewFile?.url && (
                    <a href={previewFile?.url} target="_blank">
                        <span className='block bg-uiUpload p-3 text-xs border-solid border border-t-0 border-uiUploadBorder text-kenticoblue underline'>{previewFile?.label}</span>
                    </a>
                )}
                {reg && rules && rules.required && <input type="text" {...reg} style={{display: "none"}} /> }
            </div>
            {error && <span className='text-red text-xs'>{error}</span>}
        </div>
    )
};

export default UploadField;